import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles<Theme>(theme => ({
    influencerSubmenu: {
        width: '100%',
        justifyContent: 'space-around',
        paddingTop: '2rem',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            flexDirection: 'column',
            paddingLeft: '1.5rem',
            gap: '1rem',
        },
    },
    influencerSubmenuLink: {
        color: '#7a7883',
        fontSize: '18px',
    },
}));
